/**
 * Configuration for mutation error translation
 * Contains Spanish translations for entities and field names
 */

import type { Operation } from './get-mutation-error.types';

export const OPERATION_LABELS: Record<Operation, string> = {
  create: 'crear',
  update: 'actualizar',
  delete: 'eliminar',
  fetch: 'obtener',
  generate: 'generar',
  copy: 'copiar',
  assign: 'asignar',
  remove: 'quitar',
};

export const ENTITY_ARTICLES: Record<string, string> = {
  usuario: 'el usuario',
  cliente: 'el cliente',
  evaluación: 'la evaluación',
  zona: 'la zona',
  peligro: 'el peligro',
  medida: 'la medida',
  máquina: 'la máquina',
  documento: 'el documento',
  tarea: 'la tarea',
  comentario: 'el comentario',
  norma: 'la norma',
  'tipo de cliente': 'el tipo de cliente',
  'tipo de máquina': 'el tipo de máquina',
  'tipo de peligro': 'el tipo de peligro',
  'estado de evaluación': 'el estado de evaluación',
  límite: 'el límite',
  intervención: 'la intervención',
  resultado: 'el resultado',
  'medida de control': 'la medida de control',
  'template de medida': 'el template de medida',
  clasificación: 'la clasificación',
  levantamiento: 'el levantamiento',
  planta: 'la planta',
  línea: 'la línea',
  'sub-máquina': 'la sub-máquina',
  contacto: 'el contacto',
  'norma ISO': 'la norma ISO',
  sección: 'la sección',
  cuestionamiento: 'el cuestionamiento',
  informe: 'el informe',
  'informe de diseño': 'el informe de diseño',
  reporte: 'el reporte',
};

export const FIELD_MAPPINGS: Record<string, string> = {
  // User fields
  nombre: 'El nombre',
  segundoNombre: 'El segundo nombre',
  apellido: 'El apellido',
  segundoApellido: 'El segundo apellido',
  email: 'El correo electrónico',
  password: 'La contraseña',
  cargo: 'El cargo',
  imgProfile: 'La imagen de perfil',

  // Common fields
  descripcion: 'La descripción',
  Descripcion: 'La descripción',
  codigo: 'El código',
  Codigo: 'El código',
  telefono: 'El teléfono',
  direccion: 'La dirección',
  correo: 'El correo',
  id: 'El identificador',
  fecha: 'La fecha',
  estado: 'El estado',
  tipo: 'El tipo',
  valor: 'El valor',
  imagen: 'La imagen',
  archivo: 'El archivo',
  comentario: 'El comentario',

  // Peligro fields
  idZona: 'La zona',
  idTipoPeligro: 'El tipo de peligro',
  Origen: 'El origen',
  PConsecuencia: 'La consecuencia',
  LO: 'El valor LO',
  FE: 'El valor FE',
  DPH: 'El valor DPH',
  NP: 'El valor NP',
  SeveridadDano: 'La severidad del daño',
  ProbabilidadDano: 'La probabilidad del daño',

  // Evaluacion fields
  idStatus: 'El estado',
  idMaquinaCliente: 'La máquina del cliente',
  idUserElaborado: 'El usuario elaborador',
  idUserRevisado: 'El usuario revisor',
  idUserAprobado: 'El usuario aprobador',
  idEvaluacionRiesgo: 'La evaluación de riesgo',
  idEvaluacion: 'La evaluación',

  // Zona fields
  nombre_zona: 'El nombre de la zona',
  nombreZona: 'El nombre de la zona',
  FaseVida: 'La fase de vida',
  faseVida: 'La fase de vida',
  UbicacionDePeligro: 'La ubicación del peligro',
  ubicacionPeligro: 'La ubicación del peligro',

  // Cliente fields
  nombreCliente: 'El nombre del cliente',
  idTipoCliente: 'El tipo de cliente',
  razonSocial: 'La razón social',
  rut: 'El RUT',

  // Planta fields
  nombrePlanta: 'El nombre de la planta',
  idPlanta: 'La planta',
  Pais: 'El país',
  pais: 'El país',
  Ciudad: 'La ciudad',
  ciudad: 'La ciudad',

  // Linea fields
  nombreLinea: 'El nombre de la línea',
  idLinea: 'La línea',

  // Maquina fields
  nombreMaquina: 'El nombre de la máquina',
  idTipoMaquina: 'El tipo de máquina',
  Fabricante: 'El fabricante',
  fabricante: 'El fabricante',
  modelo: 'El modelo',
  Modelo: 'El modelo',
  anoFabricacion: 'El año de fabricación',
  numeroSerie: 'El número de serie',

  // SubMaquina fields
  nombreSubMaquina: 'El nombre de la sub-máquina',
  idSubMaquina: 'La sub-máquina',

  // Medida fields
  nombreMedida: 'El nombre de la medida',
  clasificacion: 'La clasificación',
  Clasificacion: 'La clasificación',
  idClasificacion: 'La clasificación',
  efectividad: 'La efectividad',

  // Levantamiento fields
  Proyecto: 'El proyecto',
  proyecto: 'El proyecto',
  NivelSeguridadRequerido: 'El nivel de seguridad requerido',
  CodigoLevantamiento: 'El código del levantamiento',
  FechaUltimaRevision: 'La fecha de última revisión',

  // Intervención fields
  nombreIntervencion: 'El nombre de la intervención',
  idIntervencion: 'La intervención',

  // Cuestionamiento fields
  pregunta: 'La pregunta',
  respuesta: 'La respuesta',
  observacion: 'La observación',

  // Document fields
  Tipo: 'El tipo',
  Nombre: 'El nombre',
  Version: 'La versión',
  version: 'La versión',

  // Tarea fields
  nombreTarea: 'El nombre de la tarea',
  idTarea: 'La tarea',

  // Norma fields
  nombreNorma: 'El nombre de la norma',
  codigoNorma: 'El código de la norma',

  // Sección fields
  nombreSeccion: 'El nombre de la sección',
  porcentajeCumplimiento: 'El porcentaje de cumplimiento',

  // Informe fields
  tituloInforme: 'El título del informe',
  contenido: 'El contenido',

  // Contacto fields
  nombreContacto: 'El nombre del contacto',
  emailContacto: 'El correo del contacto',
  telefonoContacto: 'El teléfono del contacto',
  cargoContacto: 'El cargo del contacto',
};

/**
 * Patterns that indicate internal/database errors (backend bugs, not user errors)
 * Users can't do anything about these - show generic message
 */
export const INTERNAL_ERROR_PATTERNS = [
  // MySQL/MariaDB errors
  /unknown column/i,
  /unknown database/i,
  /table .* doesn't exist/i,
  /no database selected/i,
  /syntax error/i,
  /you have an error in your sql syntax/i,
  /column count doesn't match/i,
  /data too long for column/i,
  /incorrect .* value/i,
  /field list/i,
  /er_parse_error/i,
  /er_no_such_table/i,
  /er_bad_field_error/i,
  /er_wrong_value_count/i,
  /er_data_too_long/i,

  // TypeORM/QueryBuilder errors
  /querybuilder/i,
  /entitymetadatanotfounderror/i,
  /cannot read propert/i,
  /undefined is not an object/i,
  /null is not an object/i,
  /typeorm/i,

  // Connection errors
  /econnrefused/i,
  /econnreset/i,
  /etimedout/i,
  /connection refused/i,
  /connection reset/i,

  // Generic internal patterns
  /internal server error/i,
  /unexpected error/i,
  /something went wrong/i,
];
